import { Drawer } from '@mui/material'
import type React from 'react'
import { useState, useRef } from 'react'

import { RequestType } from '@/types/Recommendation'

import { useRequestsData } from './hooks/useRequestsData'
import RequestsFormView from './RequestsFormView'
import RequestsListView from './RequestsListView'
import type { SubjectData } from './types'

interface Props {
  setOpen: (open: boolean) => void
  subjectData: SubjectData
}

const Requests: React.FC<Props> = ({ setOpen, subjectData }) => {
  const [activeRequestType, setActiveRequestType] = useState<RequestType>(
    RequestType.OPEN_BANKING,
  )
  const [viewMode, setViewMode] = useState<'list' | 'form'>('list')
  const [isFormSubmitting, setIsFormSubmitting] = useState(false)

  const scrollRef = useRef<HTMLDivElement>(null)

  const {
    activeRecommendations,
    completeRecommendations,
    recommendationsCountByType,
    activeRequestActivity,
    recommendationsLoading,
    refreshRecommendations,
    refreshActivities,
  } = useRequestsData(subjectData, activeRequestType)

  const handleRequestsUpdated = () => {
    refreshActivities()
    refreshRecommendations()
  }

  const hasActive = activeRecommendations.length > 0
  const buttonText =
    activeRequestType === RequestType.PAYROLL
      ? 'Send Payroll/HMRC Request'
      : 'Send Open Banking Request'

  return (
    <Drawer
      anchor="right"
      open
      onClose={() => setOpen(false)}
      ModalProps={{
        keepMounted: true,
        disableScrollLock: true,
        BackdropProps: {
          invisible: true,
        },
      }}
      PaperProps={{
        sx: {
          width: '40%',
          borderLeft: '2px solid #f2f2f2',
          boxShadow: 'none',
        },
      }}
    >
      {viewMode === 'list' && (
        <RequestsListView
          activeRequestType={activeRequestType}
          setActiveRequestType={setActiveRequestType}
          scrollRef={scrollRef}
          activeRecommendations={activeRecommendations}
          completeRecommendations={completeRecommendations}
          recommendationsCountByType={recommendationsCountByType}
          activeRequestActivity={activeRequestActivity}
          recommendationsLoading={recommendationsLoading}
          isFormSubmitting={isFormSubmitting}
          hasActive={hasActive}
          buttonText={buttonText}
          subjectData={subjectData}
          handleRequestsUpdated={handleRequestsUpdated}
          setViewMode={setViewMode}
        />
      )}

      {viewMode === 'form' && (
        <RequestsFormView
          activeRequestType={activeRequestType}
          subjectData={subjectData}
          incomes={subjectData.incomes ?? []}
          setViewMode={setViewMode}
          setIsFormSubmitting={setIsFormSubmitting}
          handleRequestsUpdated={handleRequestsUpdated}
        />
      )}
    </Drawer>
  )
}

export default Requests
